// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_h0-1";
export var rowFirst = "_h0-3";
export var rowLast = "_h0-5";
export var rowMiddle = "_h0-4";
export var ticketListScroll = "_h0-2";
export var ticketStack = "_h0-0";